import { CategoryDTO, CategoryEntity } from '@gearbelt/global';
import { v4 as uuidv4 } from 'uuid';

import { UpdateWorkspaceEntityDialog, type UpdateWorkspaceEntityDialogConfig } from '@/components/settings/update-workspace-entity-dialog';

const categoryConfig: UpdateWorkspaceEntityDialogConfig<CategoryDTO> = {
  title: 'Issue Categories',
  description: 'These allow you to group issues under custom categories. You can edit, remove, and add new categories. All categories are editable at once.',
  createEmptyItem: () => ({
    id: uuidv4(),
    name: '',
    entity: CategoryEntity.Issue,
    order: null,
  }),
  getValue: (item) => item.name,
  setValue: (item, value) => ({ ...item, name: value }),
};

function UpdateWorkspaceIssueCategories({
  issueCategories,
  open,
  onOpenChange,
  callback,
}: {
  issueCategories: CategoryDTO[] | undefined;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  callback: (categories: CategoryDTO[]) => void;
}) {
  return <UpdateWorkspaceEntityDialog items={issueCategories} open={open} onOpenChange={onOpenChange} callback={callback} config={categoryConfig} />;
}

export { UpdateWorkspaceIssueCategories };
